import React, { Component } from "react";
import { Helmet } from "react-helmet";

import "./style.scss";
import list from "./list_2";

export default class Roster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      artist: {},
    };
  }

  updateSearch = (e) => {
    this.setState({ keyword: e.target.value });
  };

  render() {
    let unique = [...new Set(list)];
    const filterList = unique.filter((l) => {
      return this.state.keyword === ""
        ? true
        : l.name.toLowerCase().includes(this.state.keyword.toLowerCase());
    });
    const hash = filterList.filter((l) => {
      return (
        l.name[0].toLowerCase() === "1" ||
        l.name[0].toLowerCase() === "2" ||
        l.name[0].toLowerCase() === "3" ||
        l.name[0].toLowerCase() === "4" ||
        l.name[0].toLowerCase() === "5" ||
        l.name[0].toLowerCase() === "6" ||
        l.name[0].toLowerCase() === "7" ||
        l.name[0].toLowerCase() === "8" ||
        l.name[0].toLowerCase() === "9" ||
        l.name[0].toLowerCase() === "0" ||
        l.name[0].toLowerCase() === "#" ||
        l.name[0].toLowerCase() === "&"
      );
    });
    const a = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "a";
    });
    const b = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "b";
    });
    const c = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "c";
    });
    const d = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "d";
    });
    const e = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "e";
    });
    const f = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "f";
    });
    const g = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "g";
    });
    const h = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "h";
    });
    const i = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "i";
    });
    const j = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "j";
    });
    const k = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "k";
    });
    const l = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "l";
    });
    const m = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "m";
    });
    const n = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "n";
    });
    const o = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "o";
    });
    const p = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "p";
    });
    const q = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "q";
    });
    const r = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "r";
    });
    const s = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "s";
    });
    const t = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "t";
    });
    const u = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "u";
    });
    const v = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "v";
    });
    const w = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "w";
    });
    const x = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "x";
    });
    const y = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "y";
    });
    const z = filterList.filter((l) => {
      return l.name[0].toLowerCase() === "z";
    });
    return (
      <div className="aboss__roster">
        <Helmet>
          <title>
            ABOSS Roster - Selection of artists being booked through ABOSS
          </title>
          <meta
            name="description"
            content="ABOSS Roster - Selection of artists being booked through ABOSS"
          />
        </Helmet>
        <h1>ABOSS Roster</h1>
        <h2>Selection of artists being booked through ABOSS</h2>
        <input
          type="search"
          placeholder="Search on artist name"
          onChange={this.updateSearch}
        />

        {this.state.artist && this.state.artist.name && (
          <div className="aboss__roster-artist">
            <div className="aboss__roster-artist-container">
              <div
                className="aboss__roster-artist-container-image"
                style={{
                  backgroundImage: "url(" + this.state.artist.image + ")",
                }}
              ></div>
              <div>
                <div
                  className="aboss__roster-artist-container-close"
                  onClick={() => this.setState({ artist: {} })}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </div>
                <h1>{this.state.artist.name}</h1>

                <ul>
                  {this.state.artist.genre.split(",").map((g) => {
                    return <li>{g}</li>;
                  })}
                </ul>

                <iframe
                  src={`https://open.spotify.com/embed/artist/${this.state.artist.spotify}`}
                  width="430"
                  height="200"
                  frameborder="0"
                  allowtransparency="true"
                  allow="encrypted-media"
                ></iframe>
              </div>
            </div>
          </div>
        )}

        <div className="aboss__roster-artists">
          <ul>
            {hash.length > 0 && (
              <li>
                #
                <ul>
                  {hash.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {a.length > 0 && (
              <li>
                A
                <ul>
                  {a.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {b.length > 0 && (
              <li>
                B
                <ul>
                  {b.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {c.length > 0 && (
              <li>
                C
                <ul>
                  {c.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {d.length > 0 && (
              <li>
                D
                <ul>
                  {d.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {e.length > 0 && (
              <li>
                E
                <ul>
                  {e.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {f.length > 0 && (
              <li>
                F
                <ul>
                  {f.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {g.length > 0 && (
              <li>
                G
                <ul>
                  {g.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
          </ul>
          <ul>
            {h.length > 0 && (
              <li>
                H
                <ul>
                  {h.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {i.length > 0 && (
              <li>
                I
                <ul>
                  {i.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {j.length > 0 && (
              <li>
                J
                <ul>
                  {j.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {k.length > 0 && (
              <li>
                K
                <ul>
                  {k.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {l.length > 0 && (
              <li>
                L
                <ul>
                  {l.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {m.length > 0 && (
              <li>
                M
                <ul>
                  {m.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {n.length > 0 && (
              <li>
                N
                <ul>
                  {n.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {o.length > 0 && (
              <li>
                O
                <ul>
                  {o.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
          </ul>
          <ul>
            {p.length > 0 && (
              <li>
                P
                <ul>
                  {p.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {q.length > 0 && (
              <li>
                Q
                <ul>
                  {q.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {r.length > 0 && (
              <li>
                R
                <ul>
                  {r.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {s.length > 0 && (
              <li>
                S
                <ul>
                  {s.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {t.length > 0 && (
              <li>
                T
                <ul>
                  {t.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {u.length > 0 && (
              <li>
                U
                <ul>
                  {u.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {v.length > 0 && (
              <li>
                V
                <ul>
                  {v.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {w.length > 0 && (
              <li>
                W
                <ul>
                  {w.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {x.length > 0 && (
              <li>
                X
                <ul>
                  {x.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {y.length > 0 && (
              <li>
                Y
                <ul>
                  {y.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
            {z.length > 0 && (
              <li>
                Z
                <ul>
                  {z.map((artist) => {
                    return (
                      <li onClick={() => this.setState({ artist: artist })}>
                        {artist.name}
                      </li>
                    );
                  })}
                </ul>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/roster/index.js